import { render, staticRenderFns } from "./ReposListAdminTable.vue?vue&type=template&id=15642c1b&"
import script from "./ReposListAdminTable.vue?vue&type=script&lang=js&"
export * from "./ReposListAdminTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports